import { Box, Button, Grid, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

export default function ImmunologyTestForm({ defaultValues, onSubmit }) {
  const { register, handleSubmit } = useForm({ defaultValues: defaultValues || {} });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="CRP" size="small" variant="outlined" name="crp" {...register('crp')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HIV" size="small" variant="outlined" name="hiv" {...register('hiv')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HBsAg" size="small" variant="outlined" name="hbsag" {...register('hbsag')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="VDRL" size="small" variant="outlined" name="vdrl" {...register('vdrl')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="RA Factor" size="small" variant="outlined" name="rafactor" {...register('rafactor')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HCV" size="small" variant="outlined" name="hcv" {...register('hcv')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HAV" size="small" variant="outlined" name="hav" {...register('hav')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HEV" size="small" variant="outlined" name="hev" {...register('hev')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="ASO Titer" size="small" variant="outlined" name="asoTire" {...register('asoTire')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Widal Test" size="small" variant="outlined" name="widalTest" {...register('widalTest')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Salmonella Typhi O" size="small" variant="outlined" name="salmonellaTyphilO" {...register('salmonellaTyphilO')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Salmonella Typhi H" size="small" variant="outlined" name="salmonellaTyphiH" {...register('salmonellaTyphiH')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Salmonella Para A (H)" size="small" variant="outlined" name="salmonellaParaAH" {...register('salmonellaParaAH')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Salmonella Para B (H)" size="small" variant="outlined" name="salmonellaParaBH" {...register('salmonellaParaBH')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="H. Pylori Antibody" size="small" variant="outlined" name="hPyloriAntibody" {...register('hPyloriAntibody')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="H. Pylori Antigen" size="small" variant="outlined" name="hPyloriAntigen" {...register('hPyloriAntigen')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">सुरक्षित गर्नुहोस्</Button>
      </Box>
    </form>
  );
}
